var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExclamationMark2 = function SvgExclamationMark2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.9 883.6c0-65.7 49.7-113.9 112.8-113.9 63.2 0 111.3 48.2 111.3 113.9s-48.1 113.9-111.3 113.9c-63.1 0-112.8-48.2-112.8-113.9M418 168.4 413.5 2H588l-6 166.4-24.1 497.7H442.1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExclamationMark2);
export default ForwardRef;